<!--邀请成员-->
<template>
  <el-dialog
    title="邀请成员"
    width="800px"
    :visible="show"
    @open="open()"
    @close="close()"
    :close-on-click-modal="false"
  >
    <div class="dialog-box">
      <i class="warn-img el-icon-warning" style="vertical-align: top; margin-top: 3px"></i>
      <p class="warn-text">邀请成员加入，授权给对方印章、模板，被授权的成员则可代表企业发起、审批、签署文件；若想通过邮箱邀请成员，请前往国际版本</p>
      <el-form
        ref="dialogModelAddMember"
        :rules="formAddMemberRules"
        label-position="right"
        label-width="0"
        :model="dialogModelAddMember"
      >
<!--        <el-form-item style="width: 45%; display: inline-block" label="成员类型">-->
<!--          &lt;!&ndash; <el-select-->
<!--            size="mini"-->
<!--            v-model="dialogModelAddMember.type"-->
<!--            @change="handleChangeMemberType"-->
<!--            placeholder="请选择"-->
<!--            style="width: 260px"-->
<!--          >-->
<!--            <el-option label="个人" :value="0"></el-option>-->
<!--            <el-option label="企业" :value="1"></el-option>-->
<!--          </el-select> &ndash;&gt;-->
<!--          <p style="font-weight:600">{{dialogModelAddMember.type === 0 ? '个人' : ''}}</p>-->
<!--        </el-form-item>-->
        <el-form-item style="width: 45%; display: inline-block" label="" v-if="dialogModelAddMember.type === 0" prop="phone">
         <p style="height: 20px; line-height: 20px"><span style="color: #ec1c1c">*</span>手机号</p>
          <el-input
            size="mini"
            v-model="dialogModelAddMember.phone"
            :maxlength="11"
            placeholder="请输入手机号"
            style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 45%; display: inline-block" label="" v-if="dialogModelAddMember.type === 1" prop="email">
          <p style="height: 20px; line-height: 20px"><span style="color: #ec1c1c">*</span>邮箱</p>
          <el-input
            size="mini"
            v-model="dialogModelAddMember.email"
            :maxlength="32"
            placeholder="请输入邮箱"
            style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 45%; display: inline-block" label="" v-if="dialogModelAddMember.type === 0" prop="name">
          <p style="height: 20px; line-height: 20px"><span style="color: #ec1c1c">*</span>姓名</p>
          <el-input
            size="mini"
            v-model="dialogModelAddMember.name"
            :maxlength="32"
            placeholder="请输入姓名"
            style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 45%; display: inline-block" label="" v-if="dialogModelAddMember.type === 1" prop="enterpriseName">
          <p style="height: 20px; line-height: 20px"><span style="color: #ec1c1c">*</span>企业名称</p>
          <el-input
            size="mini"
            v-model="dialogModelAddMember.enterpriseName"
            :maxlength="32"
            placeholder="请输入企业名称"
            style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="department">
          <p style="height: 20px; line-height: 20px"><span style="color: #ec1c1c">*</span>部门</p>
          <el-popover
            placement="right"
            width="250"
            v-model="visibleChangeSelectStatus"
            trigger="click"
          >
            <!-- member tree -->
            <el-tree
              class="member-tree"
              style="max-height: 400px; overflow-y: auto"
              :data="treeGroup"
              :highlight-current="true"
              :expand-on-click-node="false"
              node-key="corpGroupId"
              :default-expand-all="true"
              :props="defaultProps"
              @node-click="handleNodeClickSelect"
            >
              <div slot-scope="{ node, data }" style="width: 100%" :title="data.groupName">
                <p
                  class="name"
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    max-width: 100%;
                    padding-right: 50px;
                  "
                >{{ data.groupName }}</p>
              </div>
            </el-tree>
            <el-input
              slot="reference"
              v-model="dialogModelAddMember.departmentName"
              readonly
              size="mini"
              placeholder="请选择"
              style="width: 260px"
            >
              <i
                slot="suffix"
                :class="{
                  'el-icon-arrow-down': true,
                  'custom-transform-rotateZ-180': visibleChangeSelectStatus,
                  'custom-transform-rotateZ-0': !visibleChangeSelectStatus,
                }"
                style="font-size: 15px; color: #cccccc"
              ></i>
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="" v-if="seals.length > 0">
          <span>选择授权给成员的印章</span>
          <div class="seal-box">
            <div
              v-for="(seal, index) in seals"
              :key="index"
              :id="'sealMenu' + index"
              class="seal-item"
              :class="[seal.select ? 'seal-select' : 'unselect']"
              @click="selectItem(seal)"
            >
              <div class="bo-top">
                <img :src="seal.sealUrl" />
              </div>
              <p>{{ seal.sealName }}</p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close()">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="onlyClickOnce"
        @click="addMemberSubmit()"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setCurrentUser } from "../../assets/js/http-serve/corp/common";
import showRes from "@/assets/js/http-serve/corp/showApiRes";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import {
  name,
  enterpriseName,
  mobile,
  email
} from "../../assets/js/lib/valid-methods";
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";

export default {
  name: "addMember",
  props: {
    show: {
      type: Boolean,
      default: true
    },
    callback: {
      // 邀请成员后的回调
      type: Function,
      default: null
    },
    sealsProps: {
      type: Object,
      default: () => { }
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  data () {
    return {
      // 1265 需求变量 start
      seals: [],
      gantConf,
      // 1265 需求变量 end
      onlyClickOnce: false,
      dialogModelAddMember: {
        type: 0,
        phone: "",
        email: "",
        name: "",
        enterpriseName: "",
        department: "",
        departmentName: "",
        showSet: false
      },
      formAddMemberRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: mobile, trigger: "change" },
          { validator: this.checkUser, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          { validator: email, trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: name, trigger: "change" }
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          { validator: enterpriseName, trigger: "change" }
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "change" }
        ]
      },
      defaultProps: {
        children: "childCorpGroups",
        label: "groupName"
      },
      // 部门选择 展开关闭状态
      visibleChangeSelectStatus: false,
      treeGroup: [],
      departmentArray: [],
      treeGroupCopy: [],
      treeGroupKeys: [],
      selectTreeNode: {}
    };
  },
  created () { },
  mounted () {
    if (
      this.allAuthUser.accountInfoVO &&
      this.allAuthUser.accountInfoVO.identityAuth == 1
    ) {
      this.initTreeGroup();
      this.getAllSeals();
    }
  },
  watch: {
    sealsProps: function (val) {
      if (!val.success) {
        val.description ? showRes(val) : "";
        return;
      }
      let seals = val.data;
      seals.forEach(seal => {
        seal.sealUrl = fileOperShow(seal.sealFile);
      });
      seals.sort((a, b) => {
        return a.corpSealId - b.corpSealId;
      });
      this.seals = seals;
    },
    show (val) {
      if (val) {
        const child =
          this.treeGroup &&
          this.treeGroup.length === 1 &&
          this.treeGroup[0] &&
          this.treeGroup[0].childCorpGroups &&
          this.treeGroup[0].childCorpGroups.length === 0;
        if (child)
          setTimeout(() => {
            this.$message.warning("当前企业未创建部门，请创建后进行操作");
          }, 1000);
      }
    }
  },
  methods: {
    checkUser (rule, value, callback) {
      if (value) {
        const param = {
          targetId: value,
          useStatus: "",
          inviteStatus: "",
          corpRoleId: "",
          corpGroupId: "",
          useType: "",
          permId: 3 // 不知道什么意思，后端说写死
        };
        ApiCorpMethods.MemberController.listCorpUsers(param)
          .then(res => {
            const user = res.data[0];
            const status =
              (user && user.useStatus === 0) ||
              (user && user.useStatus === -1 && user.inviteStatus === 0);
            if (res.success && status) {
              callback(new Error("已邀请该成员/该成员已加入企业"));
            }
            callback();
          })
          .catch(error => {
            console.info(error);
          });
      }
    },
    selectItem (seal) {
      let { select } = seal;
      this.$set(seal, "select", !select);
    },
    /**查询签章列表 */
    async getAllSeals () {
      let res = await ApiCorpMethods.SealController.seals();
      if (!res.success) {
        showRes(res);
        return;
      }
      let seals = res.data;
      seals.forEach(seal => {
        seal.sealUrl = fileOperShow(seal.sealFile);
      });
      seals.sort((a, b) => {
        return a.corpSealId - b.corpSealId;
      });
      this.seals = seals;
    },
    open () {
      if (this.$refs["dialogModelAddMember"]) {
        this.$refs["dialogModelAddMember"].resetFields();
      }
      this.dialogModelAddMember.type = 0;
      this.dialogModelAddMember.department = "";
      this.dialogModelAddMember.departmentName = "";
      this.initTreeGroup();
      // this.$emit('update:show', true)
    },
    close () {
      this.$emit("update:show", false);
    },
    // 成员类型change事件
    handleChangeMemberType (val) {
      if (this.$refs["dialogModelAddMember"]) {
        this.$refs["dialogModelAddMember"].resetFields();
      }
    },
    // select 部门
    handleNodeClickSelect (data) {
      if (data) {
        // if (data.disabled) return this.$message.error("请选择部门进行邀请");
        this.dialogModelAddMember.departmentName = data.groupName;
        this.dialogModelAddMember.department = data.corpGroupId;
      } else {
        this.dialogModelAddMember.departmentName = "";
        this.dialogModelAddMember.department = "";
      }
      this.visibleChangeSelectStatus = false;
    },
    // 初始化组织机构数据
    initTreeGroup () {
      let params = {};
      params.permId = 3;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (res.code === "0") {
            this.treeGroup = this.convertFormateTree(res.data);
            this.treeGroupCopy = JSON.parse(JSON.stringify(this.treeGroup));
            this.selectTreeNode = this.treeGroupCopy[0]; // 赋初值
            // 默认选中第一个
            this.$nextTick(() => {
              if (this.$refs.memberTree && this.$refs.memberTree.$el) {
                let firstTreeItem = this.$refs.memberTree.$el.querySelector(
                  "div"
                );
                firstTreeItem && firstTreeItem.classList.add("is-current");
              }
            });
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.description);
        });
    },
    // convert data for tree formate
    // 转换成tree需要的数据格式
    convertFormateTree (data) {
      data.forEach((element, i) => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (i === 0 && this.allAuthUser.accountInfoVO.userType === 1) element.disabled = true;
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    recursionChildren (childCorpGroups) {
      childCorpGroups.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        this.treeGroupKeys.push(element.corpGroupId);
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    // 添加成员 确认
    addMemberSubmit () {
      this.onlyClickOnce = true;
      this.$refs["dialogModelAddMember"].validate(valid => {
        if (valid) {
          let params = {};
          params.userType = this.dialogModelAddMember.type; // 0个人1企业
          let targetId =
            this.dialogModelAddMember.type === 0
              ? this.dialogModelAddMember.phone
              : this.dialogModelAddMember.email;
          params.targetId = targetId; // 手机或邮箱
          let userName =
            this.dialogModelAddMember.type === 0
              ? this.dialogModelAddMember.name
              : this.dialogModelAddMember.enterpriseName;
          params.userName = userName; // 用户名称(名称大于1个字小于50个字)
          params.corpGroupId = this.dialogModelAddMember.department; // 归属部门
          // 授权印章
          let empowerSeal = this.seals
            .filter(seal => {
              return seal.select == true;
            })
            .map(item => {
              return item.corpSealId;
            });
          if (empowerSeal.length > 0) {
            params.corpSealIds = empowerSeal.toString();
            this.requestFn(params);
          } else {
            this.$confirm("没授权印章则不能正常发起合同", "系统提示", {
              confirmButtonText: "确定",
              type: "warning"
            })
              .then(() => {
                this.requestFn(params);
              })
              .catch(() => {
                this.onlyClickOnce = false;
              });
          }
        } else {
          this.onlyClickOnce = false;
        }
      });
    },
    requestFn (params) {
      ApiCorpMethods.MemberController.addCorpUser(params)
        .then(res => {
          this.onlyClickOnce = false;
          if (res.code === "0") {
            // this.$message.success(res.description)
            this.$message.success('邀请已发送，现在可以给成员分配管理权限')
            this.close();
            // this.queryTool()
            this.$emit("refresh", false);
            this.callback && this.callback();
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.onlyClickOnce = false;
          this.$message.error(error.description);
        });
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      // const { manCorpUser } = this.allAuthUser;
      // return manCorpUser ? manCorpUser.perms : [];
      const { perms } = this.currentAuthUser;
      return perms ? perms : [];
    },
    permsAllAuth () {
      const { manCorpUser } = this.allAuthUser;
      return manCorpUser ? manCorpUser.perms : [];
    }
  }
};
</script>

<style lang="less" scoped>
  .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-dialog__header {
  }
  /deep/ .el-dialog__body {
    padding: 0 20px 10px !important;
  }
.seal-box {
  height: 280px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  .seal-item {
    width: 127px;
    margin: 0 20px 20px 0;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #ec1c1c;
  }
  .unselect {
    border: 1px solid #ccc;
  }
  .seal-select {
    border: 2px solid #ec1c1c !important;
  }
  .bo-top {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 5px;
    > img {
      width: 100%;
    }
  }
  p {
    padding: 0 3px;
    text-align: center;
    background-color: #ccc;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.dialog-box {
  /*height: 600px;*/
  overflow: auto;
}
.warn-text{
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #290202;
  margin-bottom: 20px;
  width: 95%;
  display: inline-block;
}
.warn-img {
  color: #e6a23c;
  font-size: 18px;
}
.warn-img::before {
  content: "\E7A3";
}
</style>




// WEBPACK FOOTER //
// components/console/addMember.vue